import { useEffect } from "react";
import EndOfDayDetails from "./EndOfDayDetails";
import EndOfDayForm from "./EndOfDayForm";
import useSalesEndOfDay from "./useSalesEndOfDay";

const SaleEndOfDay = ({
  isViaSellMode = false,
  props,
  setProps = () => {},
}) => {
  const { endOfDayDetails, setEndOfDayDetails, ...rest } = useSalesEndOfDay();

  useEffect(() => {
    if (!endOfDayDetails)
      setProps({
        ...props,
        hasPrevNavigation: false,
        routeToPrev: null,
      });
  }, [endOfDayDetails]);

  return (
    <>
      {!endOfDayDetails ? (
        <EndOfDayForm
          isViaSellMode={isViaSellMode}
          props={props}
          setProps={setProps}
          {...rest}
        />
      ) : (
        <EndOfDayDetails
          endOfDayDetails={endOfDayDetails}
          setEndOfDayDetails={setEndOfDayDetails}
          setProps={setProps}
          props={props}
          {...rest}
        />
      )}
    </>
  );
};
export default SaleEndOfDay;
